(function () {
  document.querySelectorAll('[data-predictive-input]').forEach(function (input) {
    var panel = input.form && input.form.querySelector('[data-predictive-panel]');
    if (input.type === 'search') input.type = 'text';
    input.setAttribute('inputmode', 'search');
    input.setAttribute('enterkeyhint', 'search');
    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-haspopup', 'listbox');
    if (!input.getAttribute('aria-label')) {
      input.setAttribute('aria-label', input.placeholder || 'Ara');
    }
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-expanded', input.getAttribute('aria-expanded') || 'false');
    if (panel && panel.id) input.setAttribute('aria-controls', panel.id);
  });
})();
